export enum LocalProvidersKeys {
  ageConfirmationActive = "ageConfirmationActive",
}
